import { Typography } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";

interface TransportMitRechnung {
  rechnung_id?: string;
}

interface FuhrparkeintragMitTransporten {
  materialanfuhr?: TransportMitRechnung[];
  materialabtransport?: TransportMitRechnung[];
  materialtransport?: TransportMitRechnung[];
}

export function hatVerknuepfteRechnungen(
  fuhrparkeintraege: FuhrparkeintragMitTransporten[] | undefined
): boolean {
  return (fuhrparkeintraege ?? []).some((fuhrparkeintrag) =>
    [
      fuhrparkeintrag.materialanfuhr,
      fuhrparkeintrag.materialabtransport,
      fuhrparkeintrag.materialtransport,
    ].some((transporte) =>
      (transporte ?? []).some((transport) => !!transport.rechnung_id)
    )
  );
}

export default function VerknuepfteRechnungenHinweis({
  gesperrt = false,
}: {
  gesperrt?: boolean;
}) {
  const { t } = useTranslation("taetigkeitsbericht");
  const { values } = useFormikContext<{
    fuhrparkeintraege?: FuhrparkeintragMitTransporten[];
  }>();

  if (!gesperrt && !hatVerknuepfteRechnungen(values.fuhrparkeintraege))
    return null;

  return (
    <Typography
      variant="h5"
      color={"error"}
      sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}
    >
      <DescriptionIcon fontSize="inherit" />
      {gesperrt
        ? t("linked-invoices-present-no-permission")
        : t("linked-invoices-present")}
    </Typography>
  );
}
